












































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const Root = namespace("root");

@Component({})
export default class editMultiLanguage extends Vue {
  @Root.State languageList;
  dialogVisible: boolean = false;

  ruleForm: any = {
    mutiLang: ""
  };
  get rules() {
    return {
      productName: [
        {
          required: true,
          message: this.$t("Product.require"),
          trigger: "blur"
        },
        {
          max: 100,
          message: this.$t("Basic.required_100_char")
        }
      ],
      requireOption: [
        {
          required: true,
          message: this.$t("Product.require"),
          trigger: "blur"
        }
      ],
      skuName: [
        {
          required: true,
          trigger: "blur",
          message: this.$t("Product.require")
        },
        {
          max: 50,
          message: this.$t("Basic.required_50_char")
        }
      ]
    };
  }
  @Prop({ default: () => {} }) editData;
  @Prop({ default: "" }) code;
  @Prop({ default: "requireOption" }) rule;
  @Prop({ default: "text" }) inputType;

  @Watch("dialogVisible")
  watchDialogVisible(val) {
    let $form: any = this.$refs.form;
    if (val) {
      let $form: any = this.$refs.form;
      $form && $form.clearValidate();
      this.ruleForm = {
        mutiLang: {
          ...this.editData
        }
      };
    } else {
      $form && $form.resetFields();
    }
  }
  handleSubmit() {
    const $form: any = this.$refs["form"];
    $form.validate(valid => {
      if (valid) {
        this.handleConfirm();
      }
    });
  }
  handleConfirm() {
    this.$emit("save", this.ruleForm.mutiLang);
    this.dialogVisible = false;
  }
}
